import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from "recharts";
import { useOrdersQuery } from "../utils/queries.js";
import {
  ChartCard,
  ChartCardFooter,
  chartDefaultWeekDataObject,
  ChartNoDataFound,
  ChartsTooltip,
  useEffect,
  useState,
  weekDaysToArrayOfObjects,
} from "@";
import { ordersChartColors } from "../utils/options.js";

// Component to display donations data in a bar chart
const Donations = () => {
  const [data, setData] = useState(chartDefaultWeekDataObject);
  const [searchDuration, setSearchDuration] = useState(3);

  // Use React Query to fetch orders data
  const { data: ordersData } = useOrdersQuery(searchDuration);

  // Update data when query result changes
  useEffect(() => {
    if (ordersData) {
      setData(weekDaysToArrayOfObjects(ordersData));
    }
  }, [ordersData]);

  return (
    <>
      {/* Card component to display the donations chart */}
      <ChartCard
        searchDurationUpdated={(value) => setSearchDuration(value)}
        title="التبرعات"
      >
        <div className="-mx-2 h-40 lg:-mx-4">
          {data?.weekDays?.length > 0 ? (
            <ResponsiveContainer width="100%" height="100%">
              {/* Bar chart to display donations data */}
              <BarChart margin={{ top: 30 }} barSize={10} data={data.weekDays}>
                <Tooltip content={<ChartsTooltip prefix="عدد الطلبات" />} />

                {/* X-axis for the bar chart */}
                <XAxis
                  reversed
                  fontSize={10}
                  interval={0}
                  dataKey="key"
                  strokeWidth={0}
                />

                {/* Bar component to display the donation values */}
                <Bar
                  background={{ fill: "#E9E9E9", radius: [10, 10, 10, 10] }}
                  radius={[10, 10, 10, 10]}
                  dataKey="value"
                >
                  {/* Cells for each bar in the chart */}
                  {data?.weekDays.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={ordersChartColors[index % ordersChartColors.length]}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <ChartNoDataFound />
          )}
        </div>
        {/* Card footer to display additional information */}
        <ChartCardFooter
          prefix="ر.س"
          percent={data?.percentage}
          number={data?.total}
          searchDuration={searchDuration}
        />
      </ChartCard>
    </>
  );
};

export default Donations;
